export const sideMenu = [
  {
    name: "Books",
    icon: "home-line",
    mode: "home",
  },
  {
    name: "Favorites",
    icon: "heart",
    mode: "favorite",
  },

  {
    name: "Notes",
    icon: "idea-line",
    mode: "note",
  },
  {
    name: "Highlights",
    icon: "highlight-line",
    mode: "digest",
  },
  {
    name: "Deleted Books",
    icon: "trash-line",
    mode: "trash",
  },
];
